import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const DROPDOWN_WIDTH = 130;

export default function CategoryDropdown({ categories, value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const selected = categories.find((c) => String(c.id) === String(value));
  const label = !value || value === 'all' ? 'All' : (selected?.name ?? 'All');

  const pick = (id) => {
    onChange(id);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative', flexShrink: 0, width: DROPDOWN_WIDTH, boxSizing: 'border-box' }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '4px',
          width: '100%',
          height: '44px',
          padding: '0 10px',
          background: '#F3F4F6',
          border: '1px solid #E5E7EB',
          borderRight: 'none',
          borderRadius: '6px 0 0 6px',
          fontSize: '12px',
          fontWeight: '500',
          color: '#374151',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
        }}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</span>
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            fontSize: '9px',
            color: '#9CA3AF',
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s',
          }}
        />
      </button>

      {open && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 6px)',
          left: 0,
          width: '200px',
          background: '#FFFFFF',
          border: '1px solid #E5E7EB',
          borderRadius: '8px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
          padding: '4px',
          zIndex: 70,
          boxSizing: 'border-box',
          maxHeight: '280px',
          overflowY: 'auto',
        }}>
          <button
            type="button"
            onClick={() => pick('all')}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '7px 10px',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: !value || value === 'all' ? '600' : '400',
              color: !value || value === 'all' ? '#EA580C' : '#374151',
              background: !value || value === 'all' ? '#FFF7ED' : 'transparent',
              cursor: 'pointer',
            }}
          >
            All Categories
          </button>
          {categories.map((cat) => {
            const isActive = String(value) === String(cat.id);
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => pick(cat.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                  textAlign: 'left',
                  padding: '7px 10px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: isActive ? '600' : '400',
                  color: isActive ? '#EA580C' : '#374151',
                  background: isActive ? '#FFF7ED' : 'transparent',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = '#F9FAFB'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
              >
                {cat.image && (
                  <img
                    src={process.env.REACT_APP_IMAGE_URL + cat.image}
                    alt=""
                    style={{ width: '18px', height: '18px', objectFit: 'cover', borderRadius: '3px', flexShrink: 0 }}
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                )}
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{cat.name}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}